import React, { PureComponent } from 'react';
import uploadIcon from "./../../media/icons/upload.svg"

class DragAndDropUpload extends PureComponent {

  state = {
    drag: false
  };

  dropRef = React.createRef();
  dragCounter = 0;

  handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter++;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ drag: true })
    }
  };
  handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter--;
    if (this.dragCounter > 0)
      return;
    this.setState({ drag: false })
  };
  handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({drag: false});
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      this.props.handleDrop(e, e.dataTransfer.files[0]);
      e.dataTransfer.clearData();
      this.dragCounter = 0
    }
  };

  componentDidMount() {
    this.dragCounter = 0;
    let div = this.dropRef.current;
    div.addEventListener('dragenter', this.handleDragIn);
    div.addEventListener('dragleave', this.handleDragOut);
    div.addEventListener('dragover', this.handleDrag);
    div.addEventListener('drop', this.handleDrop);
  }

  componentWillUnmount() {
    let div = this.dropRef.current;
    div.removeEventListener('dragenter', this.handleDragIn);
    div.removeEventListener('dragleave', this.handleDragOut);
    div.removeEventListener('dragover', this.handleDrag);
    div.removeEventListener('drop', this.handleDrop);
  }

  static defaultProps = {
    height: "100%"
  };


  render() {
    const { height } = this.props;
    const { drag } = this.state;
    return (
      <div style={{ height }} className="container-fluid" ref={this.dropRef}>
        <div className="row h-100 justify-content-center align-items-center">
          {drag ? <img className="position-absolute" src={uploadIcon} style={{opacity: 0.7 }} width="50px" height="50px" alt=""/> : this.props.children}
        </div>
      </div>
    )
  }
}

export default DragAndDropUpload;
